import { IconButton, Popover, TextField } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import TextsmsIcon from '@material-ui/icons/Textsms';
import { ICellRendererParams } from 'ag-grid-community';
import styled from 'styled-components';
import { EditContext } from '.';
import defaults from '../../translations/en.json';

const DetailsContainer = styled.div`
  padding: 10px;
  min-width: 300px;
  max-width: 300px;
  max-height: 400px;
  white-space: pre-wrap;
  font-size: 13px;
`;

const getIconColor = (hasText: boolean, editing: boolean): any =>
  !editing && !hasText
    ? { htmlColor: '#c5c1c1ff' }
    : { color: hasText ? 'primary' : 'secondary' };

export const DetailsRenderer = (params: ICellRendererParams) => {
  const { details } = params.data;

  const { editState, setEditState } = useContext(EditContext);

  const editing = editState && params.node.rowPinned === 'top';

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null,
  );

  const [text, setText] = useState('');

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    if (editing && text) {
      setEditState({ ...editState, details: text });
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <IconButton aria-describedby={id} onClick={handleClick}>
        <TextsmsIcon {...getIconColor(!!details, editing)} />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <DetailsContainer>
          {editing ? (
            <TextField
              multiline
              minRows={5}
              fullWidth
              label={defaults.incidentDetails}
              defaultValue={editState.details}
              focused
              inputProps={{ style: { fontSize: '13px' } }}
              onChange={(e) => setText(e.target.value)}
            />
          ) : (
            details || <em>{defaults.noDetails}</em>
          )}
        </DetailsContainer>
      </Popover>
    </div>
  );
};
